module.exports = __webpack_public_path__ + "img/2.70004e30.png";